import React from 'react';
import InfluencersList from '../components/InfluencersList';
import MainLayout from '../pages/MainLayout';

function Dashboard() {
  return (
    <MainLayout>
      <InfluencersList />
    </MainLayout>
  );
}

export default Dashboard;
